<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
    <fuse-vertical-navigation
            class="dark bg-gray-900 print:hidden"
            [mode]="'over'"
            [name]="'mainNavigation'"
            [navigation]="navigation?.default"
            [opened]="false">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="flex items-center h-20 pt-6 px-8 mb-8">
                <img
                        class="w-full"
                        src="assets/images/logo/univillage.jpg"
                        alt="Univillage">
            </div>
        </ng-container>
    </fuse-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="modern-shell flex flex-col flex-auto w-full min-w-0">
<!--    <div-->
<!--            *ngIf="showLoader"-->
<!--            class="absolute inset-x-0 bottom-0">-->
<!--        <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>-->
<!--    </div>-->
    <!-- Header -->
    <header class="modern-header print:hidden">
        <ng-container *ngIf="!isScreenSmall">
            <!-- Logo -->
            <a class="brand-mark" [routerLink]="['/']" aria-label="Scientifica home">
                <div class="hidden lg:flex">
                    <img
                            class="dark:hidden"
                            src="assets/images/logo/univillage.jpg"
                            alt="Univillage">
<!--                    <img-->
<!--                            class="hidden dark:flex w-24"-->

<!--                            src="assets/images/logo/logoScientifica.webp">-->
                </div>
                <img
                        class="flex lg:hidden"
                        src="assets/images/logo/univillage.jpg"
                        alt="Univillage">
            </a>

            
            <!-- Horizontal navigation -->
            <fuse-horizontal-navigation
                    class="modern-navigation"
                    [name]="'mainNavigation'"
                    [navigation]="navigation?.horizontal"></fuse-horizontal-navigation>
        </ng-container>

        <!-- Navigation toggle button -->
        <ng-container *ngIf="isScreenSmall">
            <button class="mobile-menu-button"
                    mat-icon-button
                    (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
        </ng-container>
        <!-- Components -->
        <div class="modern-user ml-auto">
<!--            <languages></languages>-->
<!--            <nebula-fullscreen class="hidden md:block"></nebula-fullscreen>-->
<!--            <search [appearance]="'bar'"></search>-->


            <user></user>
        </div>
    </header>

    <!-- Content -->
    <div class="flex flex-col flex-auto w-full">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!--    <div class="relative flex flex-0 items-center w-full h-14 sm:h-20 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">-->
    <!--        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>-->
    <!--    </div>-->

</div>

<!-- Quick chat -->
